import { render, staticRenderFns } from "./prosrtype.vue?vue&type=template&id=d1c48a42&scoped=true&"
import script from "./prosrtype.vue?vue&type=script&lang=js&"
export * from "./prosrtype.vue?vue&type=script&lang=js&"
import style0 from "./prosrtype.vue?vue&type=style&index=0&id=d1c48a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c48a42",
  null
  
)

export default component.exports